import * as React from 'react'

import { Box, CardInfo, ProgressBar, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import type Form from 'modules/surveys/store/models/Form'

import Item from './Item'

interface Props {
  form: Form
  header: React.ReactNode
}

function Stats({ form, header }: Props) {
  useAsyncData(() => form.fetch(), [])

  const author = users.find({
    id: form.attributes.access_id,
  })
  const nextCycle = form.attributes.next_cycle

  return (
    <CardInfo header={header}>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Item label={i18n.t('surveys.form.configuration.stats.author')}>
          <Text.Normal>
            {author
              ? getFullDisplayName({
                  firstName: author.attributes.first_name,
                  lastName: author.attributes.last_name,
                })
              : '-'}
          </Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.periodicity.label')}>
          <Text.Normal>{form.periodicity}</Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.configuration.stats.start_on')}>
          <Text.Normal>
            {form.attributes.start_on ? dateBackendDateTimeToUI(form.attributes.start_on) : '-'}
          </Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.configuration.stats.end_on')}>
          <Text.Normal>
            {form.attributes.end_on ? dateBackendDateTimeToUI(form.attributes.end_on) : '-'}
          </Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.configuration.stats.next_cycle')}>
          <Text.Normal>{nextCycle ? dateBackendDateTimeToUI(nextCycle) : '-'}</Text.Normal>
        </Item>
        <Item grow label={i18n.t('surveys.form.configuration.stats.participation')}>
          {form.isDraft ? (
            '-'
          ) : (
            <ProgressBar
              showLabel
              amount={form.attributes.answered_question_groups_count}
              total={form.attributes.question_groups_count}
            />
          )}
        </Item>
      </Box>
    </CardInfo>
  )
}

export default observer(Stats)
